<ngx-simplebar #simplebarMultimedia class="px-3 mx-n3 mb-2"
    style="height: calc(100vh - calc(70px + 1.5rem + 60px + 125px));" [options]="{ forceVisible: true }">
    <div class="row position-relative">
        <div class="col-lg-12">

            <div class="card-header"
                [ngClass]="{'pt-0': permissionsService.checkPropertyAgentPermission(property, 'EDIT_PROPERTIES') || (permissionsService.canEditProperty(loginUser, property?.store?.id) || permissionsService.canEditPropertyWithoutAgent(property)) || !property}">
                <div class="row">
                    <div [ngClass]="{'d-flex justify-content-between align-items-center': filterredVideos?.length > 0 && filterredImages?.length > 0}"
                        class="col-12">
                        <ng-container
                            *ngIf="permissionsService.checkPropertyAgentPermission(property, 'EDIT_PROPERTIES') || (permissionsService.canEditProperty(loginUser, property?.store?.id) || permissionsService.canEditPropertyWithoutAgent(property)) || !property">
                            <div *ngIf="filterredVideos?.length > 0 && filterredImages?.length > 0 && galleryFilter ==='images'"
                                class="form-check form-switch form-switch-md form-switch-primary">
                                <input id="imageFirst" (change)="multimediaFirst = 1"
                                    [attr.disabled]="multimediaFirst === 1 ? true : null"
                                    class="form-check-input opacity-100" type="checkbox" role="switch"
                                    [checked]="multimediaFirst === 1" />
                                <label for="imageFirst" class="form-check-label text-body opacity-100">
                                    {{'t-show-images-first' | translate}}
                                </label>
                            </div>
                            <div *ngIf="filterredVideos?.length > 0 && filterredImages?.length > 0 && galleryFilter ==='videos'"
                                class="form-check form-switch form-switch-md form-switch-primary">
                                <input id="videoFirst" (change)="multimediaFirst = 2" [checked]="multimediaFirst === 2"
                                    [attr.disabled]="multimediaFirst === 2 ? true : null"
                                    class="form-check-input opacity-100" type="checkbox" role="switch" />
                                <label for="videoFirst" class="form-check-label text-body opacity-100">
                                    {{'t-show-videos-first' | translate}}
                                </label>
                            </div>

                            <button type="button"
                                class="btn btn-outline-primary waves-effect waves-primary py-1 float-end"
                                (click)="subscribeModal(subscribeDataModal)" *ngIf="galleryFilter === 'videos'">
                                <i class="ri-add-line align-bottom me-1"> </i>
                                {{ 't-add' | translate}}
                                {{ 't-m-properties.t-videos' | translate }}
                            </button>

                            <button type="button"
                                class="btn btn-soft-primary waves-effect waves-primary py-1 float-end ms-2"
                                (click)="openHomeStagingModal(homeStagingModal)"
                                *ngIf="homeStagingAvailable && galleryFilter ==='images'">
                                <i class="ri-magic-line align-bottom me-1"> </i>
                                {{ 'home-staging-ai.button' | translate }}
                            </button>

                            <!-- BAIXAR TODAS -->
                        <button
                            type="button"
                            class="btn btn-outline-secondary waves-effect py-1 float-end ms-2"
                            (click)="downloadAllImages()"
                            *ngIf="galleryFilter === 'images' && filterredImages?.length > 0"
                        >
                            <i class="ri-download-2-line align-bottom me-1"></i>
                            Baixar todas
                        </button>

                            <button type="button"
                                class="btn btn-outline-primary waves-effect waves-primary py-1 float-end"
                                (click)="addImage()" *ngIf="galleryFilter ==='images' || galleryFilter ==='plan'">
                                <i class="ri-add-line align-bottom me-1"> </i>
                                {{ 't-add' | translate }}
                                {{ 't-m-properties.t-images' | translate }}
                            </button>
                            <input hidden type="file" (change)="onFileChange($event)" id="input-file-img"
                                accept="image/png,image/jpg,image/jpeg,image/webp" multiple />
                        </ng-container>

                    </div>
                </div>
            </div>

            <!-- Preparação das fotos novas: uma de cada vez, com progresso -->
            <div class="multimedia-progress" *ngIf="uploadProgress" role="status" aria-live="polite">
                <div class="d-flex justify-content-between align-items-center mb-1">
                    <span class="multimedia-progress-title">
                        <span class="spinner-border spinner-border-sm text-primary me-2" aria-hidden="true"></span>
                        {{ 't-preparing-images' | translate:{ current: uploadProgress.current, total: uploadProgress.total } }}
                    </span>
                    <small class="text-muted text-truncate ms-2 multimedia-progress-name">{{ uploadProgress.name }}</small>
                </div>
                <div class="progress progress-sm">
                    <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
                        [style.width.%]="uploadProgress.total ? (uploadProgress.current / uploadProgress.total) * 100 : 0"></div>
                </div>
            </div>

            <!-- WARNING -->
            <div class="multimedia-warning-wrap">
                <div *ngIf="showMultimediaMinWarning" class="multimedia-warning-banner" role="alert">
                    <span class="multimedia-warning-icon" aria-hidden="true">
                        <i class="ri-error-warning-fill"></i>
                    </span>

                    <div class="multimedia-warning-content">
                        <p class="multimedia-warning-title mb-0">
                            {{ 't-m-properties.t-multimedia' | translate }}
                        </p>

                        <small class="multimedia-warning-subtitle">
                            {{ 't-multimedia-min'
                            | translate:{ min: multimediaMinError?.valueMin, current: multimediaMinError?.activeCount }
                            }}
                        </small>
                    </div>
                </div>
            </div>

            <div class="card-body">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="text-center">
                            <ul class="list-inline categories-filter animation-nav" id="filter">
                                <li class="list-inline-item">
                                    <a class="categories py-1 bg-light" data-filter=".images"
                                        (click)="activeCategory('images')"
                                        [ngClass]="{'active': galleryFilter ==='images'}" style="font-weight: 400;">
                                        <i class="ri-image-fill label-icon align-middle fs-16 me-2"></i>
                                        {{ 't-m-properties.t-images' | translate }}
                                    </a>
                                </li>
                                <li class="list-inline-item">
                                    <a class="categories py-1 bg-light" data-filter=".videos"
                                        (click)="activeCategory('videos')"
                                        [ngClass]="{'active': galleryFilter ==='videos'}" style="font-weight: 400;">
                                        <i class="ri-video-line label-icon align-middle fs-16 me-2"></i>
                                        {{ 't-m-properties.t-videos' | translate }}
                                    </a>
                                </li>
                                <!-- <li class="list-inline-item"><a class="categories" data-filter=".plan"
                                        (click)="activeCategory('plan')"
                                        [ngClass]="{'active': galleryFilter ==='plan'}">Plan</a></li> -->
                            </ul>
                        </div>

                        <div class="row gallery-wrapper" *ngIf="galleryFilter ==='images'">
                            <!-- Border spinner -->
                           <div
                                class="element-item col-xxl-3 col-xl-4 col-sm-6 project designing development image-sort-item"
                                data-category="designing development"
                                *ngFor="let data of filterredImages; let i=index"

                                [attr.draggable]="canEditMultimedia() ? 'true' : 'false'"

                                (dragstart)="onImageDragStart($event, i)"
                                (dragover)="onImageDragOver($event, i)"
                                (drop)="onImageDrop($event, i)"
                                (dragend)="onImageDragEnd()"

                                [class.is-dragging]="draggedImageIndex === i"

                                [class.drop-before]="
                                    dragOverImageIndex === i &&
                                    dragOverPosition === 'before'
                                "

                                [class.drop-after]="
                                    dragOverImageIndex === i &&
                                    dragOverPosition === 'after'
                                "
                            >
                                <div class="gallery-box card">
                                    <div class="gallery-container">
                                        <a class="image-popup" title="">
                                            <img class="gallery-img img-fluid mx-auto" [src]="data?.img" alt=""
                                                (error)="onImageError($event, data)" />
                                            <div class="gallery-overlay" (click)="open(i)">
                                                <h5 class="overlay-caption">{{data?.caption}}</h5>
                                            </div>
                                        </a>
                                    <!-- Recorte reposto: o servidor volta ao automático ao guardar -->
                                    <span class="badge badge-soft-info gallery-crop-badge"
                                        *ngIf="data?.cropDirty && !data?.crop">
                                        <i class="ri-crop-line align-middle me-1"></i>{{ 't-crop-auto-after-save' | translate }}
                                    </span>

                                    <!-- Regulamento IA da UE (art. 50): marca discreta "IA" sobre a capa; esbatida quando desligada -->
                                    <div class="gallery-ai-control" [class.gallery-ai-control-off]="!data?.isAiGenerated"
                                        (click)="$event.stopPropagation()">
                                        <div class="form-check form-switch form-switch-warning m-0">
                                            <input class="form-check-input" type="checkbox" role="switch"
                                                id="SwitchAi{{data?.id}}" [ngModel]="data?.isAiGenerated"
                                                [disabled]="!(permissionsService.checkPropertyAgentPermission(property, 'EDIT_PROPERTIES') || (permissionsService.canEditProperty(loginUser, property?.store?.id) || permissionsService.canEditPropertyWithoutAgent(property)) || !property)"
                                                (ngModelChange)="onChangeAiGenerated($event,data)">
                                            <label class="form-check-label" for="SwitchAi{{data?.id}}">IA</label>
                                        </div>
                                        <i class="ri-information-line gallery-ai-info" [ngbTooltip]="'t-ai-image.t-help' | translate"
                                            container="body"></i>
                                    </div>

                                         <!-- DOWNLOAD DA IMAGEM -->
                                    <button
                                        type="button"
                                        class="gallery-download-btn"
                                        (click)="$event.stopPropagation(); downloadImage(data)"
                                        ngbTooltip="Baixar imagem"
                                        container="body"
                                        aria-label="Baixar imagem"
                                    >
                                        <i class="ri-download-2-line"></i>
                                    </button>
                                    </div>

                                    <div class="box-content">

                                        <div class="mt-2"
                                            [ngStyle]="{'cursor': permissionsService.checkPropertyAgentPermission(property, 'EDIT_PROPERTIES') || (permissionsService.canEditProperty(loginUser, property?.store?.id) || permissionsService.canEditPropertyWithoutAgent(property)) || !property?null:'not-allowed'}">
                                            <input class="form-control form-control-sm" type="text"
                                                placeholder="Caption" [ngModel]="data?.caption"
                                                (ngModelChange)="onchangeCaption($event,data)"
                                                [ngStyle]="{'pointer-events': permissionsService.checkPropertyAgentPermission(property, 'EDIT_PROPERTIES') || (permissionsService.canEditProperty(loginUser, property?.store?.id) || permissionsService.canEditPropertyWithoutAgent(property)) || !property?null:'none'}">
                                        </div>

 

                                        <!-- Stacks - Horizontal -->
                                        <div class="hstack gap-3 mt-1"
                                            *ngIf="permissionsService.checkPropertyAgentPermission(property, 'EDIT_PROPERTIES') || (permissionsService.canEditProperty(loginUser, property?.store?.id) || permissionsService.canEditPropertyWithoutAgent(property)) || !property">
                                            <div>
                                                <button type="button"
                                                    class="btn btn-sm btn-outline-danger btn-icon waves-effect waves-light mt-1"
                                                    (click)="deleteImage(data)"><i class="ri-delete-bin-5-line"
                                                        style="font-size: 1rem;"></i></button>
                                            </div>
                                            <div *ngIf="canCrop(data)">
                                                <button type="button"
                                                    class="btn btn-sm btn-outline-primary btn-icon waves-effect waves-light mt-1"
                                                    [class.btn-outline-warning]="isLegacyCrop(data)"
                                                    [ngbTooltip]="isLegacyCrop(data) ? ('t-crop-legacy-limited' | translate) : ('t-crop-image' | translate)"
                                                    container="body"
                                                    (click)="cropImage(data)">
                                                    <i class="ri-crop-line" style="font-size: 1rem;"></i></button>
                                            </div>
                                            <div *ngIf="homeStagingAvailable && data?.isAvailable !== false">
                                                <button type="button"
                                                    class="btn btn-sm btn-soft-primary btn-icon waves-effect waves-light mt-1"
                                                    [ngbTooltip]="'home-staging-ai.tooltip' | translate"
                                                    container="body"
                                                    (click)="openHomeStagingModal(homeStagingModal, data)">
                                                    <i class="ri-magic-line" style="font-size: 1rem;"></i>
                                                </button>
                                            </div>
                                            <div *ngIf="imageEnhancementAvailable && data?.isAvailable !== false">
                                                <button type="button"
                                                    class="btn btn-sm btn-soft-info btn-icon waves-effect waves-light mt-1"
                                                    [ngbTooltip]="'image-enhancement-ai.tooltip' | translate"
                                                    container="body"
                                                    (click)="openImageEnhancementModal(imageEnhancementModal, data)">
                                                    <i class="ri-image-edit-line" style="font-size: 1rem;"></i>
                                                </button>
                                            </div>
                                            <div>
                                                <div class="form-check form-switch form-switch-primary pt-2">
                                                    <input class="form-check-input" type="checkbox" role="switch"
                                                        id="SwitchCheck{{data?.id}}" checked [ngModel]="data?.status"
                                                        (ngModelChange)="onChangeActive($event,data)">
                                                </div>
                                            </div>
                                            <div>
                                                <select class="form-select form-select-sm"
                                                    aria-label=".form-select-sm example"
                                                    (change)="onchangeImageOrder($event, data)">
                                                    <option [attr.selected]="(j+1)===data?.id?true:null"
                                                        *ngFor="let data2 of filterredImages; let j=index"
                                                        [value]="(j+1)">
                                                        {{(j+1)}}º
                                                    </option>
                                                </select>
                                            </div>

                                          <!-- <div class="form-select form-select-sm image-order-display">
                                            {{ i + 1 }}º
                                            </div> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- end row -->
                        </div>
                        <div class="row gallery-wrapper" *ngIf="galleryFilter ==='videos'">
                            <!-- Border spinner -->
                            <div class="element-item col-xxl-3 col-xl-4 col-sm-6 project designing development"
                                data-category="designing development" *ngFor="let data of filterredVideos; let i=index">
                                <div class="gallery-box card">
                                    <div class="gallery-container">
                                        <a class="image-popup" title="">
                                            <!-- <img class="gallery-img img-fluid mx-auto" src="{{data?.link}}" alt=""
                                                *ngIf="!data?.autoCrop" /> -->
                                            <div class="ratio" style="--vz-aspect-ratio: 67%;">
                                                <iframe [src]="data?.link" title="YouTube video"
                                                    allowfullscreen></iframe>
                                            </div>
                                            <div class="gallery-overlay" (click)="open(i)">
                                                <h5 class="overlay-caption">{{data?.caption}}</h5>
                                            </div>
                                        </a>
                                    </div>

                                    <div class="box-content">

                                        <div class="mt-2 d-none"
                                            [ngStyle]="{'cursor': permissionsService.checkPropertyAgentPermission(property, 'EDIT_PROPERTIES') || (permissionsService.canEditProperty(loginUser, property?.store?.id) || permissionsService.canEditPropertyWithoutAgent(property)) || !property?null:'not-allowed'}">
                                            <input class="form-control form-control-sm" type="text"
                                                placeholder="Caption"
                                                [ngStyle]="{'pointer-events': permissionsService.checkPropertyAgentPermission(property, 'EDIT_PROPERTIES') || (permissionsService.canEditProperty(loginUser, property?.store?.id) || permissionsService.canEditPropertyWithoutAgent(property)) || !property?null:'none'}">
                                        </div>
                                        <!-- Stacks - Horizontal -->
                                        <div class="hstack gap-3 mt-1"
                                            *ngIf="permissionsService.checkPropertyAgentPermission(property, 'EDIT_PROPERTIES') || (permissionsService.canEditProperty(loginUser, property?.store?.id) || permissionsService.canEditPropertyWithoutAgent(property)) || !property">
                                            <div>
                                                <button type="button"
                                                    class="btn btn-sm btn-outline-danger btn-icon waves-effect waves-light mt-1"
                                                    (click)="deleteVideo(data)"><i class="ri-delete-bin-5-line"
                                                        style="font-size: 1rem;"></i></button>
                                            </div>

                                            <div>
                                                <div class="form-check form-switch form-switch-primary pt-2">
                                                    <input class="form-check-input" type="checkbox" role="switch"
                                                        id="SwitchCheck3" checked>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- end row -->
                        </div>
                    </div>
                    <!-- end row -->
                </div>
                <!-- ene card body -->
            </div>
            <!-- end card -->

            <!-- end col -->
        </div>
        <!-- <div *ngFor="let data of filterredImages">
            <app-cropperr [imgData]="data" [autoCrop]="true" *ngIf="data?.isNew && data?.autoCrop"></app-cropperr>
        </div> -->

        <app-cropperr></app-cropperr>



        <!-- Home Staging AI Modal -->
        <ng-template #homeStagingModal let-modal>
            <div class="modal-content border-0 overflow-hidden home-staging-shell">
                <div class="modal-header home-staging-header py-3">
                    <div class="home-staging-title-wrap">
                        <span class="home-staging-header-icon">
                            <i class="ri-magic-line"></i>
                        </span>
                        <div>
                            <h5 class="modal-title mb-1">
                                {{ 'home-staging-ai.title' | translate }}
                            </h5>
                            <p class="mb-0">{{ 'home-staging-ai.subtitle' | translate }}</p>
                        </div>
                    </div>
                    <button type="button" class="btn-close btn-close-white" aria-label="Close"
                        (click)="dismissHomeStagingModal(modal)"></button>
                </div>

                <div class="modal-body p-0">
                    <div class="home-staging-grid">
                        <div class="home-staging-panel">
                            <div class="home-staging-section-title">
                                <span>01</span>
                                <div>
                                    <h6>{{ 'home-staging-ai.previewTitle' | translate }}</h6>
                                    <p>{{ 'home-staging-ai.sourceImage' | translate }}</p>
                                </div>
                            </div>

                            <ng-select [items]="filterredImages" bindLabel="name" [clearable]="false"
                                [searchable]="false" [ngModel]="homeStagingSelectedImage"
                                (ngModelChange)="onHomeStagingSelectedImageChange($event)"
                                [ngModelOptions]="{standalone: true}" class="home-staging-select mb-3">
                                <ng-template ng-label-tmp let-item="item">
                                    <span>{{ item?.caption || item?.name || ('home-staging-ai.image' | translate) }}</span>
                                </ng-template>
                                <ng-template ng-option-tmp let-item="item">
                                    <div class="home-staging-option">
                                        <img [src]="item?.img" alt="" />
                                        <span>{{ item?.caption || item?.name || ('home-staging-ai.image' | translate) }}</span>
                                    </div>
                                </ng-template>
                            </ng-select>

                            <div class="home-staging-source" *ngIf="homeStagingSelectedImage">
                                <img [src]="homeStagingSelectedImage?.img" alt="" />
                                <span>{{ 'home-staging-ai.before' | translate }}</span>
                            </div>

                            <div class="home-staging-section-title mt-4">
                                <span>02</span>
                                <div>
                                    <h6>{{ 'home-staging-ai.settingsTitle' | translate }}</h6>
                                    <p>{{ 'home-staging-ai.settingsSubtitle' | translate }}</p>
                                </div>
                            </div>

                            <div class="row g-3">
                                <div class="col-md-6">
                                    <label class="form-label">{{ 'home-staging-ai.roomType' | translate }}</label>
                                    <ng-select [items]="homeStagingRoomOptions" bindValue="value"
                                        [clearable]="false" [searchable]="false"
                                        [(ngModel)]="homeStagingForm.roomType"
                                        [ngModelOptions]="{standalone: true}" class="home-staging-select">
                                        <ng-template ng-label-tmp let-item="item">
                                            <span>{{ item?.labelKey | translate }}</span>
                                        </ng-template>
                                        <ng-template ng-option-tmp let-item="item">
                                            <span>{{ item?.labelKey | translate }}</span>
                                        </ng-template>
                                    </ng-select>
                                </div>
                                <div class="col-md-6">
                                    <label class="form-label">{{ 'home-staging-ai.style' | translate }}</label>
                                    <ng-select [items]="homeStagingStyleOptions" bindValue="value"
                                        [clearable]="false" [searchable]="false"
                                        [(ngModel)]="homeStagingForm.style"
                                        [ngModelOptions]="{standalone: true}" class="home-staging-select">
                                        <ng-template ng-label-tmp let-item="item">
                                            <span>{{ item?.labelKey | translate }}</span>
                                        </ng-template>
                                        <ng-template ng-option-tmp let-item="item">
                                            <span>{{ item?.labelKey | translate }}</span>
                                        </ng-template>
                                    </ng-select>
                                </div>
                                <div class="col-md-6">
                                    <label class="form-label">{{ 'home-staging-ai.quality' | translate }}</label>
                                    <ng-select [items]="homeStagingQualityOptions" bindValue="value"
                                        [clearable]="false" [searchable]="false"
                                        [(ngModel)]="homeStagingForm.quality"
                                        [ngModelOptions]="{standalone: true}" class="home-staging-select">
                                        <ng-template ng-label-tmp let-item="item">
                                            <span>{{ item?.labelKey | translate }}</span>
                                        </ng-template>
                                        <ng-template ng-option-tmp let-item="item">
                                            <span>{{ item?.labelKey | translate }}</span>
                                        </ng-template>
                                    </ng-select>
                                </div>
                                <div class="col-md-6">
                                    <label class="form-label">{{ 'home-staging-ai.variants' | translate }}</label>
                                    <ng-select [items]="homeStagingVariantOptions" bindValue="value"
                                        [clearable]="false" [searchable]="false"
                                        [(ngModel)]="homeStagingForm.variants"
                                        [ngModelOptions]="{standalone: true}" class="home-staging-select">
                                        <ng-template ng-label-tmp let-item="item">
                                            <span>{{ item?.labelKey | translate }}</span>
                                        </ng-template>
                                        <ng-template ng-option-tmp let-item="item">
                                            <span>{{ item?.labelKey | translate }}</span>
                                        </ng-template>
                                    </ng-select>
                                    <small class="home-staging-cost-hint">
                                        {{ 'home-staging-ai.costHint' | translate }}
                                    </small>
                                </div>
                                <div class="col-12">
                                    <label class="form-label">{{ 'home-staging-ai.instructions' | translate }}</label>
                                    <textarea class="form-control home-staging-notes" rows="3"
                                        [(ngModel)]="homeStagingForm.customInstructions"
                                        [ngModelOptions]="{standalone: true}"
                                        [placeholder]="'home-staging-ai.instructionsPlaceholder' | translate"></textarea>
                                </div>
                            </div>

                            <div class="alert alert-danger home-staging-error" *ngIf="homeStagingError">
                                <i class="ri-error-warning-line me-1"></i>
                                {{ homeStagingError }}
                            </div>
                        </div>

                        <div class="home-staging-results">
                            <div class="home-staging-results-head">
                                <div>
                                    <span class="home-staging-results-kicker">{{ 'home-staging-ai.after' | translate }}</span>
                                    <h6 class="mb-1">{{ 'home-staging-ai.results' | translate }}</h6>
                                    <small>{{ 'home-staging-ai.resultsHint' | translate }}</small>
                                </div>
                                <button type="button" class="btn home-staging-generate-btn"
                                    [disabled]="homeStagingGenerating || !homeStagingSelectedImage"
                                    (click)="generateHomeStaging()">
                                    <span class="spinner-border spinner-border-sm me-1" *ngIf="homeStagingGenerating"></span>
                                    <i class="ri-magic-line me-1" *ngIf="!homeStagingGenerating"></i>
                                    {{ 'home-staging-ai.generate' | translate }}
                                    <span class="home-staging-credit-badge">
                                        {{ getHomeStagingTotalCreditCost() }}
                                        {{ 'home-staging-ai.creditsShort' | translate }}
                                    </span>
                                </button>
                            </div>

                            <div class="home-staging-stage">
                                <div class="home-staging-empty" *ngIf="!homeStagingGenerating && homeStagingResults.length === 0">
                                    <span class="home-staging-empty-icon">
                                        <i class="ri-image-edit-line"></i>
                                    </span>
                                    <strong>{{ 'home-staging-ai.empty' | translate }}</strong>
                                </div>

                                <div class="home-staging-loading" *ngIf="homeStagingGenerating">
                                    <div class="home-staging-loader">
                                        <span></span>
                                        <i class="ri-magic-line"></i>
                                    </div>
                                    <strong>
                                        {{ homeStagingLoadingMessages[homeStagingLoadingMessageIndex] | translate }}
                                    </strong>
                                </div>

                                <div class="home-staging-result-grid" *ngIf="homeStagingResults.length > 0">
                                    <div class="home-staging-result-card" *ngFor="let image of homeStagingResults; let i = index">
                                        <div class="home-staging-compare">
                                            <img class="home-staging-compare-base"
                                                [src]="homeStagingSelectedImage?.img" alt="" />
                                            <div class="home-staging-compare-reveal"
                                                [style.clip-path]="'inset(0 ' + (100 - (image?.comparePosition ?? 50)) + '% 0 0)'">
                                                <img [src]="image?.dataUrl" alt="" />
                                            </div>
                                            <span class="home-staging-compare-label home-staging-compare-label-before">
                                                {{ 'home-staging-ai.before' | translate }}
                                            </span>
                                            <span class="home-staging-compare-label home-staging-compare-label-after">
                                                {{ 'home-staging-ai.after' | translate }}
                                            </span>
                                            <span class="home-staging-compare-divider"
                                                [style.left.%]="image?.comparePosition ?? 50">
                                                <i class="ri-arrow-left-s-line"></i>
                                                <i class="ri-arrow-right-s-line"></i>
                                            </span>
                                            <input type="range" min="0" max="100" step="1"
                                                class="home-staging-compare-range"
                                                [attr.aria-label]="'home-staging-ai.compareSlider' | translate"
                                                [ngModel]="image?.comparePosition ?? 50"
                                                (ngModelChange)="image.comparePosition = $event"
                                                [ngModelOptions]="{standalone: true}" />
                                        </div>
                                        <div class="home-staging-result-actions">
                                            <span>{{ 'home-staging-ai.resultBadge' | translate:{ index: i + 1 } }}</span>
                                            <div>
                                                <button type="button" class="btn btn-light btn-sm btn-icon"
                                                    [ngbTooltip]="'home-staging-ai.download' | translate"
                                                    container="body"
                                                    (click)="downloadHomeStagingImage(image)">
                                                    <i class="ri-download-2-line"></i>
                                                </button>
                                                <button type="button" class="btn btn-primary btn-sm"
                                                    (click)="addHomeStagingImageToProperty(image)">
                                                    <i class="ri-add-line me-1"></i>
                                                    {{ 'home-staging-ai.addToProperty' | translate }}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>

        <!-- Image Enhancement AI Modal -->
        <ng-template #imageEnhancementModal let-modal>
            <div class="modal-content border-0 overflow-hidden home-staging-shell">
                <div class="modal-header home-staging-header py-3">
                    <div class="home-staging-title-wrap">
                        <span class="home-staging-header-icon">
                            <i class="ri-image-edit-line"></i>
                        </span>
                        <div>
                            <h5 class="modal-title mb-1">
                                {{ 'image-enhancement-ai.title' | translate }}
                            </h5>
                            <p class="mb-0">{{ 'image-enhancement-ai.subtitle' | translate }}</p>
                        </div>
                    </div>
                    <button type="button" class="btn-close btn-close-white" aria-label="Close"
                        (click)="dismissImageEnhancementModal(modal)"></button>
                </div>

                <div class="modal-body p-0">
                    <div class="home-staging-grid">
                        <div class="home-staging-panel">
                            <div class="home-staging-section-title">
                                <span>01</span>
                                <div>
                                    <h6>{{ 'image-enhancement-ai.previewTitle' | translate }}</h6>
                                    <p>{{ 'image-enhancement-ai.sourceImage' | translate }}</p>
                                </div>
                            </div>

                            <ng-select [items]="filterredImages" bindLabel="name" [clearable]="false"
                                [searchable]="false" [ngModel]="imageEnhancementSelectedImage"
                                (ngModelChange)="onImageEnhancementSelectedImageChange($event)"
                                [ngModelOptions]="{standalone: true}" class="home-staging-select mb-3">
                                <ng-template ng-label-tmp let-item="item">
                                    <span>{{ item?.caption || item?.name || ('image-enhancement-ai.image' | translate) }}</span>
                                </ng-template>
                                <ng-template ng-option-tmp let-item="item">
                                    <div class="home-staging-option">
                                        <img [src]="item?.img" alt="" />
                                        <span>{{ item?.caption || item?.name || ('image-enhancement-ai.image' | translate) }}</span>
                                    </div>
                                </ng-template>
                            </ng-select>

                            <div class="home-staging-source" *ngIf="imageEnhancementSelectedImage">
                                <img [src]="imageEnhancementSelectedImage?.img" alt="" />
                                <span>{{ 'image-enhancement-ai.before' | translate }}</span>
                            </div>

                            <div class="home-staging-section-title mt-4">
                                <span>02</span>
                                <div>
                                    <h6>{{ 'image-enhancement-ai.settingsTitle' | translate }}</h6>
                                    <p>{{ 'image-enhancement-ai.settingsSubtitle' | translate }}</p>
                                </div>
                            </div>

                            <div class="image-enhancement-options">
                                <button type="button" class="image-enhancement-option"
                                    *ngFor="let option of imageEnhancementOptions"
                                    [class.is-selected]="isImageEnhancementSelected(option.value)"
                                    [class.is-disabled]="!canSelectImageEnhancement(option.value)"
                                    (click)="toggleImageEnhancement(option.value)">
                                    <span class="image-enhancement-option-icon">
                                        <i [class]="option.icon"></i>
                                    </span>
                                    <span>
                                        <strong>{{ option.labelKey | translate }}</strong>
                                        <small>{{ option.descriptionKey | translate }}</small>
                                    </span>
                                    <i class="ri-check-line image-enhancement-option-check"
                                        *ngIf="isImageEnhancementSelected(option.value)"></i>
                                </button>
                            </div>

                            <small class="home-staging-cost-hint">
                                {{ 'image-enhancement-ai.selectionHint' | translate:{
                                count: getImageEnhancementSelectionCount()
                                } }}
                            </small>

                            <div class="row g-3 mt-1">
                                <div class="col-12">
                                    <label class="form-label">{{ 'image-enhancement-ai.quality' | translate }}</label>
                                    <ng-select [items]="homeStagingQualityOptions" bindValue="value"
                                        [clearable]="false" [searchable]="false"
                                        [(ngModel)]="imageEnhancementForm.quality"
                                        [ngModelOptions]="{standalone: true}" class="home-staging-select">
                                        <ng-template ng-label-tmp let-item="item">
                                            <span>{{ item?.labelKey | translate }}</span>
                                        </ng-template>
                                        <ng-template ng-option-tmp let-item="item">
                                            <span>{{ item?.labelKey | translate }}</span>
                                        </ng-template>
                                    </ng-select>
                                </div>
                                <div class="col-12">
                                    <label class="form-label">{{ 'image-enhancement-ai.instructions' | translate }}</label>
                                    <textarea class="form-control home-staging-notes" rows="3"
                                        [(ngModel)]="imageEnhancementForm.customInstructions"
                                        [ngModelOptions]="{standalone: true}"
                                        [placeholder]="'image-enhancement-ai.instructionsPlaceholder' | translate"></textarea>
                                </div>
                            </div>

                            <div class="alert alert-danger home-staging-error" *ngIf="imageEnhancementError">
                                <i class="ri-error-warning-line me-1"></i>
                                {{ imageEnhancementError }}
                            </div>
                        </div>

                        <div class="home-staging-results">
                            <div class="home-staging-results-head">
                                <div>
                                    <span class="home-staging-results-kicker">{{ 'image-enhancement-ai.after' | translate }}</span>
                                    <h6 class="mb-1">{{ 'image-enhancement-ai.results' | translate }}</h6>
                                    <small>{{ 'image-enhancement-ai.resultsHint' | translate }}</small>
                                </div>
                                <button type="button" class="btn home-staging-generate-btn"
                                    [disabled]="imageEnhancementGenerating || !imageEnhancementSelectedImage"
                                    (click)="generateImageEnhancement()">
                                    <span class="spinner-border spinner-border-sm me-1" *ngIf="imageEnhancementGenerating"></span>
                                    <i class="ri-image-edit-line me-1" *ngIf="!imageEnhancementGenerating"></i>
                                    {{ 'image-enhancement-ai.generate' | translate }}
                                    <span class="home-staging-credit-badge">
                                        {{ getImageEnhancementTotalCreditCost() }}
                                        {{ 'image-enhancement-ai.creditsShort' | translate }}
                                    </span>
                                </button>
                            </div>

                            <div class="home-staging-stage">
                                <div class="home-staging-empty"
                                    *ngIf="!imageEnhancementGenerating && imageEnhancementResults.length === 0">
                                    <span class="home-staging-empty-icon">
                                        <i class="ri-image-edit-line"></i>
                                    </span>
                                    <strong>{{ 'image-enhancement-ai.empty' | translate }}</strong>
                                </div>

                                <div class="home-staging-loading" *ngIf="imageEnhancementGenerating">
                                    <div class="home-staging-loader">
                                        <span></span>
                                        <i class="ri-image-edit-line"></i>
                                    </div>
                                    <strong>
                                        {{ imageEnhancementLoadingMessages[imageEnhancementLoadingMessageIndex] | translate }}
                                    </strong>
                                </div>

                                <div class="home-staging-result-grid" *ngIf="imageEnhancementResults.length > 0">
                                    <div class="home-staging-result-card" *ngFor="let image of imageEnhancementResults">
                                        <div class="home-staging-compare">
                                            <img class="home-staging-compare-base"
                                                [src]="imageEnhancementSelectedImage?.img" alt="" />
                                            <div class="home-staging-compare-reveal"
                                                [style.clip-path]="'inset(0 ' + (100 - (image?.comparePosition ?? 50)) + '% 0 0)'">
                                                <img [src]="image?.dataUrl" alt="" />
                                            </div>
                                            <span class="home-staging-compare-label home-staging-compare-label-before">
                                                {{ 'image-enhancement-ai.before' | translate }}
                                            </span>
                                            <span class="home-staging-compare-label home-staging-compare-label-after">
                                                {{ 'image-enhancement-ai.after' | translate }}
                                            </span>
                                            <span class="home-staging-compare-divider"
                                                [style.left.%]="image?.comparePosition ?? 50">
                                                <i class="ri-arrow-left-s-line"></i>
                                                <i class="ri-arrow-right-s-line"></i>
                                            </span>
                                            <input type="range" min="0" max="100" step="1"
                                                class="home-staging-compare-range"
                                                [attr.aria-label]="'image-enhancement-ai.compareSlider' | translate"
                                                [ngModel]="image?.comparePosition ?? 50"
                                                (ngModelChange)="image.comparePosition = $event"
                                                [ngModelOptions]="{standalone: true}" />
                                        </div>
                                        <div class="home-staging-result-actions">
                                            <span>{{ 'image-enhancement-ai.resultBadge' | translate }}</span>
                                            <div>
                                                <button type="button" class="btn btn-light btn-sm btn-icon"
                                                    [ngbTooltip]="'image-enhancement-ai.download' | translate"
                                                    container="body"
                                                    (click)="downloadImageEnhancementImage(image)">
                                                    <i class="ri-download-2-line"></i>
                                                </button>
                                                <button type="button" class="btn btn-primary btn-sm"
                                                    (click)="addImageEnhancementImageToProperty(image)">
                                                    <i class="ri-add-line me-1"></i>
                                                    {{ 'image-enhancement-ai.addToProperty' | translate }}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>

        <!-- Subscribe Modal -->
        <ng-template #subscribeDataModal let-modal>
            <div class="modal-content border-0 overflow-hidden">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalFullscreenXxlLabel">Add Video</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                        (click)="modal.dismiss('Cross click')"></button>
                </div>
                <div class="modal-body">
                    <div class="input-group py-4">
                        <input type="text" class="form-control" placeholder="link" aria-label="save link"
                            aria-describedby="button-add-video" #newLink>
                        <button class="btn btn-primary" type="button" id="button-add-video"
                            (click)="saveVideo(newLink.value)">Save</button>
                    </div>
                </div>


            </div><!-- /.modal-content -->
        </ng-template>
    </div>
</ngx-simplebar>
